import type { AlertProps } from '@mantine/core';
import type { CSSObject } from 'styled-components';
import { dsAiToolCellStyles } from '@dealstack/frontend/app/pages/Project/Cap/DealstackAi/AnalysisWorkspace/components/DataGrid/DataGrid.styles';
import {
	DS_AI_COLORS,
	DS_AI_MOTION,
} from '@dealstack/frontend/app/pages/Project/Cap/DealstackAi/theme/dealstackAi.tokens';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

const { colors } = defaultTheme.v3;

/** Name | Classification | Related people | Last updated | Pages | Actions. */
export const LIBRARY_COLUMNS = 'minmax(0, 1fr) 10rem 15rem 10rem 10rem 8rem';

/** TableToolbar cell, tinted while a filter applies. Its focus ring is the tool cell's own. */
export const dsAiToolbarButtonStyles = ({
	active,
	square,
}: {
	active?: boolean;
	square?: boolean;
}) =>
	({
		...dsAiToolCellStyles(),
		justifyContent: 'center',
		minWidth: square === true ? '3rem' : '7rem',
		padding: square === true ? '0' : '0 16px',
		background: active === true ? colors.blue[0] : 'transparent',
		transition: `background-color ${DS_AI_MOTION.fastMs}ms ${DS_AI_MOTION.easing}`,
	}) satisfies CSSObject;

/** The row's name label, truncated past the checkbox; shared by the header and the rows. */
export const NAME_LABEL_STYLES = {
	cursor: 'pointer',
	'& span': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
} satisfies CSSObject;

/** Error text takes the design's darkened `--error-text`; Mantine writes `--alert-color` inline, so only `vars` beats it. */
export const COUNT_ERROR_ALERT_VARS: AlertProps['vars'] = () => ({
	root: { '--alert-color': DS_AI_COLORS.errorText },
});
